<template>
    <v-card
            flat
            @mouseenter.native="toggleDownloadBtn"
            @mouseleave.native="toggleDownloadBtn"
    >
        <v-card-text class="px-4" ref="chartBody">
            <div class="downloadable-card-header">
                <slot name="title"></slot>
                <v-icon
                        v-show="!hideIcon && (!isComparisonPage && isDownloadBtnVisible)"
                        :disabled="isCanvasImageLoading"
                        @click="downloadChartToImage($refs.chartBody, imageName)"
                        class="text-xs-right"
                        data-html2canvas-ignore
                        small
                >
                    fas fa-download
                </v-icon>
            </div>
            <div class="chart-wrapper">
                <slot name="chart">
                    <div class="d-flex fill-height align-center" style="height: 300px">
                        <v-progress-circular
                                color="bindezcolor"
                                indeterminate
                        />
                    </div>
                </slot>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    import downloadChart from "@/mixins/downloadChart";
	export default {
		name: "AppChartWrapper",
		props: {
			hideIcon: {
				type: Boolean,
				default: false,
			},
			imageName: {
				type: String,
				required: true,
			}
		},
        mixins: [downloadChart],
        computed:{
			isComparisonPage(){
				return this.$route.name === 'comparison'
            }
        }
	}
</script>

<style scoped>

</style>

